export interface IProduct {
  id: string;
  name: string;
  description: string;
  itemQuantity: number;
  priceARS: number;
  discountARS: number;
  finalPriceARS: number;
  priceUSD: number;
  discountUSD: number;
  finalPriceUSD: number;
  type: "item" | "bundle";
}

export enum ProductType {
  ALBUMS,
  COLLECTIONS,
  SHELVINGS,
  ARTISTS,
  LABELS,
  ALBUM_FORMATS,
  ALBUM_TYPES,
  STORES,
  SELL_VALUES,
  EXCHANGE_RATES,
  TAGS,
  LISTENING_SESSIONS,
  BUNDLES
}
